// extracted by mini-css-extract-plugin
export var closeButton = "_z-1";
export var container = "_z-0";
export var fullModalImage = "_z-2";